import { CircularProgress } from '@material-ui/core';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import React from 'react';

const BarChartVentas = props => {
	const { data, initialDate, endDate, isLoading } = props;

	const formatDate = dateToTransform => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	let xAxisCategories = [];
	let totalBillActualData = [];
	let totalBillVentaNuevaData = [];
	let nuevosIngresosData = [];

	if (isLoading === false) {
		for (const element in data) {
			if (data[element].initialDate >= initialDate && data[element].initialDate <= endDate) {
				const monthYear = formatDate(data[element].initialDate);

				xAxisCategories.push(monthYear);
				totalBillActualData.push(data[element].totalBillActual);
				totalBillVentaNuevaData.push(data[element].totalBillVentaNueva);
				nuevosIngresosData.push(data[element].nuevosIngresos);
			}
		}
	}

	const options = {
		chart: {
			type: 'line',
		},
		title: {
			text: 'Ingresos Ventas',
		},
		xAxis: {
			categories: xAxisCategories,
			//allowDecimals: false,
		},
		series: [
			{
				name: 'Facturación Actual',
				type: 'column',
				data: totalBillActualData,
			},
			{
				name: 'Ingresos Venta Nueva',
				type: 'column',
				data: totalBillVentaNuevaData,
				color: 'green',
			},
			{
				name: 'Nuevos Ingresos Clientes Existentes',
				type: 'column',
				data: nuevosIngresosData,
			},
		],
	};

	return <React.Fragment>{isLoading ? <CircularProgress /> : <HighchartsReact highcharts={Highcharts} options={options} />}</React.Fragment>;
};

export default React.memo(BarChartVentas);
